import React, { useContext } from "react";
import Fade from "react-reveal/Fade";
import { GlobalStateContext } from "../../state/GlobalContextProvider";

const HeaderBanner = () => {
  const themeState = useContext(GlobalStateContext);

  return (
    <div>
      <div className="it-services-banner">
        <div className={"bannerHeader " + themeState.theme}>
          <div className="bannerTitle">
            <div className="welcome_box">
              <Fade top>
                <div className={"welcome_title " + themeState.theme}>
                  <p>
                    <span className="brand">tell.</span> Privacy Policy
                  </p>
                </div>
              </Fade>
              <Fade up>
                <div className={"welcome_subtitle " + themeState.theme}>
                  <p className="">
                    What you need to know about communicating with us
                  </p>
                </div>
              </Fade>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
